// 使用方式：和api的使用方式是一样的，看api/DemoApi 里面有记载

import { JSEncrypt } from 'jsencrypt'
export function encrypt (str) {
  var jse = new JSEncrypt()
  var public_key = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAOSkUOZBS0PLxbXn0MP+UOq7S+83X3ODHqqdVSyuwwqYyoruPHlYgyJGTPrVDuRP7BKgAYE3nUyPP2XaUw9Dbd8CAwEAAQ==';
  jse.setPublicKey(public_key)
  return jse.encrypt(str)
}
/**
 * 1、手机号验证：
 * 比较精确的匹配：^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$
 * 由于工信部放号段不定时 ^(1[2-9])\d{9}$
 */
export function TelPhone (str) {
  const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
  return reg.test(str)
}

// 2、密码验证：只能输入数字或者是字母【6-12位】
export function NumberLetter (str) {
  const reg = /^[0-9a-zA-Z]{6,}$/ // /^[a-zA-Z]|[0-9]|[a-zA-Z0-9]{6,7}$/
  return reg.test(str)
}

// 3、密码验证：可以输入任何的内容，只做长度的限制
export function NoLimitPassword (str) {
  var strLeng = str.length
  if ((strLeng > 5) && (strLeng < 13)) {
    return true
  } else {
    return false
  }
}

// 4、时间戳
export function timestamp (timestamp) {
  var variable = +new Date(timestamp) // new Date().getTime()
  return variable
}

/**
 * 5、转换成一般的时间格式
 * date：中国标准时间【Wed Jun 12 2019 10:19:25 GMT+0800】
 * fmt：输入你想要的格式，就会返回对应的格式
 * fmt：yyyy-MM-dd 返回：2019-10-09
 * fmt：MM-dd      返回：10-09
 * fmt：yyyy-MM    返回：2019-10
 */
export function formatDate (date, fmt) {
	var o = {
		'M+': date.getMonth() + 1, 	// 月
		'd+': date.getDate(), 		// 日 
		'h+': date.getHours(), 		// 时 
		'm+': date.getMinutes(), 	// 分 
		's+': date.getSeconds(), 	// 秒 
		'q+': Math.floor((date.getMonth() + 3) / 3), // 季度 
		'S': date.getMilliseconds() // 毫秒 
	};
	
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	
	for (var k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
		}
	}
  return fmt
}
function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}
// 6、人名校验【检测名字，包括少数民族的名字】
// 检测：迪丽热巴·迪力木拉提、穆克代斯·库尔班、麦迪娜·买买提、古力娜扎尔·拜合提亚尔
export function namecheck (str) {
  const reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/
  return reg.test(str)
}
// 7、电子邮箱的检测
export function Emailcheck (str) {
  // eslint-disable-next-line
  const reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
  return reg.test(str)
}
// 8、驼峰转换
export function humpcheck (str) {
  var result = Array.prototype.map.call(str, (item) => {
    return item === item.toUpperCase() ? `_${item.toLowerCase()}` : item
  }).join('')
  return result
}
// 驼峰修改
//  humpcheck2(str) {
//   var VaV = str.split('')
//   for (var i = 0; i < VaV.length; i++) {
//     if (VaV[i] === VaV[i].toUpperCase()) {
//       VaV[i] = '-' + VaV[i].toLowerCase()
//     }
//   }
//   return VaV.join('')
// }

/**
 * @功能: 判断是否为对象
 */
 export function isObject(val){
	return Object.prototype.toString.call(val) === '[object Object]';
}


export function isFunction(val){
	return Object.prototype.toString.call(val) === '[object Function]';
}

export function isNumber(val){
	return Object.prototype.toString.call(val) === '[object Number]';
}

export function getUrlParam(queryName, url = ''){
    url = url || window.location.href || ''
    url = url.split('?')[1] || ''
    var reg = new RegExp('(^|&)' + queryName + '=([^&]*)(&|$)', 'i')
    var r = url.match(reg)
    if (r != null) {
        return decodeURI(r[2])
    } else {
        return null
    }
}
export function getWinInfo(){
    if (!_gWinInfo) {
      _gWinInfo = {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  
    return _gWinInfo
  }
  // dataProcessor.js
/**
 * 将带转义字符的Markdown格式字符串转换为树形结构数据
 * @param {string} text - 带转义字符的Markdown格式字符串
 * @returns {Object} 树形结构数据
 */
export function convertTextToTree(text) {
  // 处理转义字符，将\\n转换为\n
  const processedText = text.replace(/\\\\n/g, '\n');
  
  const lines = processedText.split('\n');
  const root = { label: '', children: [] };
  const stack = [root];
  
  lines.forEach((line, index) => {
    const titleMatch = line.match(/^(#+) (.*)$/);
    if (titleMatch) {
      const level = titleMatch[1].length;
      const id = 'root_'+index;
      const label = titleMatch[2].trim();
      
      // 调整栈的长度以匹配当前标题级别
      while (stack.length > level) {
        stack.pop();
      }
      
      const parent = stack[stack.length - 1];
      const newNode = {id, label, children: [] };
      parent.children.push(newNode);
      stack.push(newNode);
    }
  });
  
  // return root.children[0]; // 返回根节点的第一个子节点;
  // 假设data已经是树形结构
  const removeEmptyChildren = (node) => {
    if (node.children && node.children.length === 0) {
      delete node.children;
    } else if (node.children) {
      node.children.forEach(child => removeEmptyChildren(child));
    }
    return node;
  };
  
  return removeEmptyChildren(root.children[0]);
}

/**
 * 为节点生成唯一ID
 */
export function generateNodeIds(tree, parentPath = '') {
  tree.id = parentPath ? `${parentPath}-${tree.label}` : tree.label;
  tree.id = tree.id.replace(/[^\w]/g, '-'); // 确保ID只包含有效字符
  
  if (tree.children && tree.children.length > 0) {
    tree.children.forEach(child => {
      generateNodeIds(child, tree.id);
    });
  }
  
  return tree;
}


// WEBPACK FOOTER //
// ./src/common/utils/filter.js